export default __webpack_public_path__ + "static/media/areas.6c2ee787.geojson";